<template>
  <div class="page">
    <div class="page-container">
      <project-page-header ref="pageHeader" :id="projectId"></project-page-header>
      <div class="page-title">项目计划</div>
      <div class="panel-body">
        <div class="w800">
          <a-steps progress-dot class="v-mt-md v-mb-lg" size="small" :current="currentStep">
            <a-step title="填报项目计划">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="data.taskState > 0">
                <div>{{ data.taskSubmitTime ? data.taskSubmitTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="项目官员审核" />
            <a-step title="项目主管审核" />
            <a-step title="完成" />
          </a-steps>
        </div>
        <a-alert class="v-mb-sm no-border" type="error" v-if="data.taskCheckResult == -1">
          <div slot="message">
            <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />提交的项目计划已被驳回</div>
            <div class="flex v-mt-xs">
              <span class="text-right text-grey">审核意见：</span>
              <span class="col text-red" v-html="$utils.convertToHtml(data.taskCheckOpinion)"></span>
            </div>
          </div>
        </a-alert>
        <div class="panel-info-section relative-position">
          <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :expanded-row-keys.sync="expandedKeys" :pagination="false" :data-source="tasks" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
            <a-table-column title="序号" data-index="index" :width="60" align="left">
              <template slot-scope="text, record">
                {{ record.no }}
              </template>
            </a-table-column>
            <a-table-column title="任务名称" data-index="taskName" :ellipsis="true" :width="280" align="left">
              <template slot-scope="text, record">
                {{ record.taskName }}
              </template>
            </a-table-column>
            <a-table-column title="任务类型" data-index="taskType" :width="80" align="center">
              <template slot-scope="text, record">
                <template v-if="!record.isRoot">{{ record.taskType }}</template>
              </template>
            </a-table-column>
            <a-table-column title="任务周期" data-index="range" :width="190" align="center">
              <template slot-scope="text, record">
                <template v-if="!record.isRoot">{{ record.startDate ? record.startDate + '~' + record.endDate : '-' }}</template>
              </template>
            </a-table-column>
            <a-table-column title="历时（天）" data-index="period" :width="90" align="center">
              <template slot-scope="text, record">
                <span v-if="record.startDate && record.endDate">{{ $utils.diffDays(record.startDate, record.endDate) }}d</span>
              </template>
            </a-table-column>
            <a-table-column title="责任人" data-index="owner" :ellipsis="true" :width="100">
              <template slot-scope="text, record">
                <span>{{ record.owner }}</span>
              </template>
            </a-table-column>
            <a-table-column title="备注" data-index="remark" :width="200" :ellipsis="true">
              <template slot-scope="text, record">
                <template v-if="!record.isRoot">{{ record.remark }}</template>
              </template>
            </a-table-column>
            <a-table-column title="对应费用明细" data-index="budget" :width="300" align="left">
              <template slot-scope="text, record">
                <template class="relative-position" v-if="!record.isRoot">
                  <ul class="cell-list" v-if="record.budgets && record.budgets.length">
                    <li v-for="item in record.budgets" :key="item.budgetId">{{ item.pname }} — {{ item.name }} / {{ $utils.thousands(item.amount) }} 元</li>
                  </ul>
                </template>
              </template>
            </a-table-column>
          </a-table>
        </div>
        <div class="text-center v-mt-lg">
          <a-space>
            <template v-if="isProcessable(data.taskState)">
              <a-button icon="rollback" type="indigo" :loading="saving" @click="handleReviewBackConfirm">驳回</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" v-if="data.taskState === 1" @click="handleConfirmReview">审核通过，提交主管审核</a-button>
              <a-button icon="arrow-right" type="primary" :loading="saving" v-else-if="data.taskState === 2" @click="handleConfirmReview">审核通过</a-button>
            </template>
            <a-button icon="left" key="backward" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
    <a-modal centered title="驳回项目计划" :visible="rejectModal" @cancel="cancelRejectModal" width="550px" :body-style="{ padding: '12px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="cancelRejectModal">取消</a-button>
          <a-button type="indigo" :loading="saving" @click="handleReview(false, 0)">确认驳回，退回至申请人</a-button>
          <a-button type="indigo" :loading="saving" @click="handleReview(false, 1)" v-if="data.taskState === 2">确认驳回，退回至官员</a-button>
        </a-space>
      </template>
      <a-textarea v-model="rejectReason" :rows="6" placeholder="输入驳回原因" ref="rejectReason" />
    </a-modal>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { viewPrj } from '@/api/project/funded'
import { getTasks, reviewTasks } from '@/api/project/common'
import { convertTasksToTableData } from '@/utils/data'
export default {
  name: 'FundedProjectChangeinfo',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: null,
      data: {},
      loading: false,
      expandedKeys: [],
      tasks: [],
      saving: false,
      currentStep: 0,
      rejectModal: false,
      rejectReason: '',
    }
  },
  computed: {
    hasChildren() {
      return this.budgetsTableData.some(item => item.children && item.children.length)
    },
    hasTaskChildren() {
      return this.tasksTableData.some(item => item.children && item.children.length)
    },
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.loadProject()
        this.loadTasks()
      }
    },
    loadProject() {
      this.loading = true
      viewPrj(this.projectId).then(({ data }) => {
        this.loading = false
        if (data.success) {
          this.data = data.result
          let { taskState } = data.result
          this.currentStep = taskState == 9 ? 3 : taskState
        }
      })
    },
    loadTasks() {
      this.loading = true
      getTasks(this.projectId).then(({ data }) => {
        if (data.success) {
          let records = convertTasksToTableData(data.result)
          this.tasks = records
          this.expandedKeys = records.filter(d => d.children && d.children.length).map(d => d.uid)
        }
      })
      this.loading = false
    },
    cancelRejectModal() {
      this.rejectModal = false
    },
    handleReviewBackConfirm() {
      this.rejectReason = ''
      this.rejectModal = true
    },
    handleConfirmReview() {
      this.$confirm({
        title: '确认审核通过？',
        centered: true,
        onOk: () => {
          this.handleReview(true)
        },
      })
    },
    handleReview(approved, backsteps = 0) {
      let { projectId, rejectReason } = this
      this.$message.destroy()
      if (!approved && rejectReason.trim() === '') {
        this.$message.warn('请输入驳回原因')
        this.$refs.rejectReason.focus()
        return
      }
      let params = {
        projectId,
        result: approved ? 1 : 0,
        backsteps,
        opinion: rejectReason.trim(),
      }
      this.saving = true
      reviewTasks(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.cancelRejectModal()
            this.$router.go(-1)
          } else {
            this.$message.warn(data.msg)
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.warn('操作失败')
        })
    },
  },
  created() {
    this.init()
  },
}
</script>
